export const isInterestFieldDefined = field => {
  return field && field !== 'other';
};